import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, MessageCircle, ArrowRight } from "lucide-react";
import { MedasLogo } from "./Header";
import { PHONE, PHONE_LINK, WHATSAPP_LINK, ADDRESS } from "../lib/data";

const Footer = () => (
  <footer className="bg-[#2A2521] pt-16 pb-28 lg:pb-10" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <MedasLogo light />
          <p className="text-white/60 text-sm mt-5 leading-relaxed max-w-xs">
            Clinică de stomatologie din Timișoara. Îngrijire dentară completă, cu încredere din 2019.
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            <span className="text-[11px] font-semibold uppercase tracking-widest text-[#DCC79A] border border-[#DCC79A]/30 rounded-full px-3 py-1">Din 2019</span>
            <span className="text-[11px] font-semibold uppercase tracking-widest text-[#DCC79A] border border-[#DCC79A]/30 rounded-full px-3 py-1">Fără durere</span>
          </div>
        </div>
        <div>
          <h4 className="font-display font-bold text-white text-sm uppercase tracking-widest">Navigare</h4>
          <ul className="mt-4 space-y-2.5">
            {[
              ["Servicii", "/servicii"],
              ["Echipă", "/echipa"],
              ["Cazuri", "/cazuri"],
              ["Despre noi", "/despre"],
              ["Recenzii", "/recenzii"],
              ["Contact", "/contact"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link to={to} data-testid={`footer-link-${label.toLowerCase().replace("ă", "a").replace(" ", "-")}`} className="text-white/60 hover:text-[#DCC79A] text-sm transition-colors inline-flex items-center gap-1.5 group">
                  <ArrowRight className="w-3 h-3 opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-display font-bold text-white text-sm uppercase tracking-widest">Program</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-white/60">
            <li className="flex justify-between gap-4 border-b border-white/10 pb-2.5">
              <span className="flex items-center gap-2"><Clock className="w-3.5 h-3.5 text-[#DCC79A]" /> Luni – Vineri</span>
              <span className="text-white/85 font-medium">08:00 – 20:00</span>
            </li>
            <li className="flex justify-between gap-4 border-b border-white/10 pb-2.5">
              <span className="flex items-center gap-2"><Clock className="w-3.5 h-3.5 text-[#DCC79A]" /> Sâmbătă</span>
              <span className="text-white/85 font-medium">09:00 – 14:00</span>
            </li>
            <li className="flex justify-between gap-4">
              <span className="flex items-center gap-2"><Clock className="w-3.5 h-3.5 text-[#DCC79A]" /> Duminică</span>
              <span className="text-white/85 font-medium">Închis</span>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-bold text-white text-sm uppercase tracking-widest">Contact</h4>
          <ul className="mt-4 space-y-3 text-sm text-white/60">
            <li className="flex items-center gap-2.5">
              <Phone className="w-4 h-4 text-[#DCC79A] shrink-0" />
              <a href={PHONE_LINK} className="hover:text-[#DCC79A] transition-colors" data-testid="footer-phone">{PHONE}</a>
            </li>
            <li className="flex items-center gap-2.5">
              <MessageCircle className="w-4 h-4 text-[#DCC79A] shrink-0" />
              <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="hover:text-[#DCC79A] transition-colors" data-testid="footer-whatsapp">Scrie-ne pe WhatsApp</a>
            </li>
            <li className="flex items-center gap-2.5">
              <Mail className="w-4 h-4 text-[#DCC79A] shrink-0" /> contact@mymedas.ro
            </li>
            <li className="flex items-center gap-2.5">
              <MapPin className="w-4 h-4 text-[#DCC79A] shrink-0" /> {ADDRESS}
            </li>
          </ul>
          <a
            href={PHONE_LINK}
            data-testid="footer-cta-button"
            className="mt-5 inline-flex items-center gap-2 bg-[#A6823B] hover:bg-[#8A6B2E] text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-all hover:-translate-y-0.5"
          >
            <Phone className="w-4 h-4" /> Programează-te
          </a>
        </div>
      </div>
      <div className="mt-12 pt-6 border-t border-white/10 flex flex-col lg:flex-row items-center justify-between gap-3">
        <p className="text-white/40 text-xs">© 2026 MEDAS Dental Point Timișoara. Toate drepturile rezervate.</p>
        <div className="flex items-center gap-5">
          <Link to="/politica-gdpr" data-testid="footer-link-gdpr" className="text-white/40 hover:text-[#DCC79A] text-xs transition-colors">Politică GDPR</Link>
          <Link to="/politica-cookies" data-testid="footer-link-cookies" className="text-white/40 hover:text-[#DCC79A] text-xs transition-colors">Politica Cookies</Link>
          <Link to="/chestionar-pacient" data-testid="footer-link-chestionar" className="text-white/40 hover:text-[#DCC79A] text-xs transition-colors">Chestionar Pacient</Link>
        </div>
        <p className="text-white/40 text-xs">Parte din rețeaua medicală MEDAS · din 2019</p>
      </div>
    </div>
  </footer>
);

export default Footer;
